import { render, staticRenderFns } from "./ConsentMappingModal.vue?vue&type=template&id=c30b4e26"
import script from "./ConsentMappingModal.vue?vue&type=script&lang=js"
export * from "./ConsentMappingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports